import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { Icon } from '@jutro/components';
import { InputField } from '@jutro/legacy/components';
import styles from './RiskTableComponent.module.scss';
import metadata from './RiskTableComponent.metadata.json5';
import { Link } from '@jutro/router';

function RiskTableComponent(props) {

    const {
        data: RiskTableVM,
        updateWizardData,
        submissionVM,
        RiskTablePath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const addRiskTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            RiskTableVM.value = RiskTableVM.value || []

            const { _xCenter, _dtoName } = RiskTableVM;
            const RiskTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            RiskTableObjVM.isValidationReq = true;

            RiskTableVM.pushElement(
                RiskTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, RiskTableVM, viewModelService]
    );

    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            RiskTableVM.value.splice(index, 1);
            _.set(submissionVM.value, RiskTablePath, RiskTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, RiskTablePath, RiskTableVM?.value]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'lifInsCarNam1') {
                const value = item.lifInsCarNam1 ? item.lifInsCarNam1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.lifInsCarNam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`RiskTableTable`]: {
            data: RiskTableVM?.value,
        }

    }), [RiskTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addRiskTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            RiskTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [RiskTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={RiskTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

RiskTableComponent.propTypes = wizardProps;
export default withRouter(RiskTableComponent);
